import { render, staticRenderFns } from "./RemoteMonitoringIndicatorTrendsView.vue?vue&type=template&id=622b7e4c"
import script from "./RemoteMonitoringIndicatorTrendsView.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringIndicatorTrendsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports